import React from 'react';
import Button from "../button";
import './index.css';

const PicButton = (props) => {

    const {className, ...other} = props;

    return (
        <Button className={`pic-button${className ? ' ' + className : ''}`} {...other}>
            {props.children}
        </Button>
    );
};

export default PicButton;
